import { render, staticRenderFns } from "./EvidenceView.vue?vue&type=template&id=700a5a5e"
import script from "./EvidenceView.vue?vue&type=script&lang=ts"
export * from "./EvidenceView.vue?vue&type=script&lang=ts"
import style0 from "./EvidenceView.vue?vue&type=style&index=0&id=700a5a5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports